import React from 'react';
import { useIntl } from 'react-intl-next';
import { selectionToolbarMessages } from '@atlaskit/editor-common/messages';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { PinIcon, PinnedIcon, ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
var shouldShowPinMenuItem = function shouldShowPinMenuItem(editMode) {
  return editMode !== 'view';
};
var usePluginState = conditionalHooksFactory(function () {
  return expValEquals('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true);
}, function (api) {
  var _useEditorToolbar = useEditorToolbar(),
    editorViewMode = _useEditorToolbar.editorViewMode,
    editorToolbarDockingPreference = _useEditorToolbar.editorToolbarDockingPreference;
  return {
    editorViewMode: editorViewMode,
    editorToolbarDockingPreference: editorToolbarDockingPreference
  };
}, function (api) {
  var editorViewMode = useSharedPluginStateSelector(api, 'editorViewMode.mode');
  var editorToolbarDockingPreference = useSharedPluginStateSelector(api, 'userPreferences.preferences.toolbarDockingPosition');
  return {
    editorViewMode: editorViewMode,
    editorToolbarDockingPreference: editorToolbarDockingPreference
  };
});

/**
 * The menu-item version of pin only appears in selection toolbar - the primary toolbar will have its own component
 */
export var PinMenuItem = function PinMenuItem(_ref) {
  var api = _ref.api;
  var intl = useIntl();
  var _usePluginState = usePluginState(api),
    editorViewMode = _usePluginState.editorViewMode,
    editorToolbarDockingPreference = _usePluginState.editorToolbarDockingPreference;
  var isToolbarDocked = editorToolbarDockingPreference === 'top';
  if (!shouldShowPinMenuItem(editorViewMode)) {
    return null;
  }
  var onClick = function onClick() {
    if (!api) {
      return;
    }
    if (isToolbarDocked) {
      var _api$selectionToolbar, _api$selectionToolbar2;
      (_api$selectionToolbar = api.selectionToolbar.actions) === null || _api$selectionToolbar === void 0 || (_api$selectionToolbar2 = _api$selectionToolbar.setToolbarDocking) === null || _api$selectionToolbar2 === void 0 || _api$selectionToolbar2.call(_api$selectionToolbar, 'none');
    } else {
      var _api$selectionToolbar3, _api$selectionToolbar4;
      (_api$selectionToolbar3 = api.selectionToolbar.actions) === null || _api$selectionToolbar3 === void 0 || (_api$selectionToolbar4 = _api$selectionToolbar3.setToolbarDocking) === null || _api$selectionToolbar4 === void 0 || _api$selectionToolbar4.call(_api$selectionToolbar3, 'top');
    }
  };
  var message = intl.formatMessage(isToolbarDocked ? selectionToolbarMessages.toolbarPositionPinedAtTop : selectionToolbarMessages.toolbarPositionUnpinnedConcise);
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: onClick,
    elemBefore: isToolbarDocked ? /*#__PURE__*/React.createElement(PinnedIcon, {
      size: "small",
      label: ""
    }) : /*#__PURE__*/React.createElement(PinIcon, {
      size: "small",
      label: ""
    })
  }, message);
};